import { VIDEO_SOURCES, EXTERNAL_VIDEO_SOURCES, } from '@wix/wix-vod-constants/common';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import { includes } from 'lodash';
export const isDownloadAllowed = (video) => video.allowDownload;
export const isExternalVideo = (video) => Boolean(video.mediaExternUrl);
export const isExternalVideoSource = (videoSource) => EXTERNAL_VIDEO_SOURCES.includes(videoSource);
export const isVideoFromComputer = ({ videoSource }) => videoSource === VIDEO_SOURCES.COMPUTER;
export const isVideoOriginallyLive = ({ videoSource }) => videoSource === VIDEO_SOURCES.LIVE;
export const isFacebookVideo = ({ videoSource }) => videoSource === VIDEO_SOURCES.FACEBOOK;
export const isYoutubeVideo = ({ videoSource }) => videoSource === VIDEO_SOURCES.YOUTUBE;
export const isLiveVideo = ({ itemType } = {}) => includes([ItemType.ItemLive, ItemType.ItemScheduled, ItemType.ItemLiveFinalize], itemType); // TODO check if works
//# sourceMappingURL=video-origin.js.map